(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["student-measurement-lookup"] && !Shopify.designMode) return;
  try {
    

function initializeSchoolayMeasurementLookup(root) {

  if (!root || root.dataset.initialized === "true") {
    return;
  }

  root.dataset.initialized = "true";

  const form =
    root.querySelector("[data-measurement-form]");

  const mobileInput =
    root.querySelector("[data-mobile-input]");

  const searchButton =
    root.querySelector("[data-search-button]");

  const message =
    root.querySelector("[data-message]");

  const loading =
    root.querySelector("[data-loading]");

  const result =
    root.querySelector("[data-result]");

  const studentSelector =
    root.querySelector("[data-student-selector]");

  const apiUrl =
    root.dataset.apiUrl || "";


  function escapeHtml(value) {
    return String(value ?? "")
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#039;");
  }


  function showMessage(text) {

    message.textContent = text;
    message.hidden = false;

  }


  function clearMessage() {

    message.textContent = "";
    message.hidden = true;

  }


  function setLoading(isLoading) {

    loading.hidden = !isLoading;

    searchButton.disabled = isLoading;

    searchButton.textContent =
      isLoading
        ? "Searching..."
        : "Search";

  }


  function formatDate(value) {

    if (!value) {
      return "";
    }

    const date = new Date(value);

    if (Number.isNaN(date.getTime())) {
      return "";
    }

    return date.toLocaleDateString(
      "en-IN",
      {
        day: "2-digit",
        month: "2-digit",
        year: "numeric"
      }
    );

  }


  function measurementRow(
    name,
    value,
    unit
  ) {

    if (
      value === null ||
      value === undefined ||
      value === ""
    ) {
      return "";
    }

    return `
      <div class="schoolay-measurement-item">
        <span class="schoolay-measurement-name">
          ${escapeHtml(name)}
        </span>

        <span class="schoolay-measurement-value">
          ${escapeHtml(value)} ${escapeHtml(unit)}
        </span>
      </div>
    `;

  }


function renderStudent(student) {

  studentSelector.hidden = true;

  const measurements =
    student.measurements || {};

  const photoUrl =
    student.photo &&
    student.photo.url
      ? student.photo.url
      : "";

  const classSection =
    student.section
      ? `${student.className} - ${student.section}`
      : student.className || "";


  const measurementHtml = [

    measurementRow(
      "Height",
      measurements.height,
      "cm"
    ),

    measurementRow(
      "Chest",
      measurements.chest,
      "in"
    ),

    measurementRow(
      "Waist",
      measurements.waist,
      "in"
    ),

    measurementRow(
      "Hip",
      measurements.hip,
      "in"
    ),

    measurementRow(
      "Shoulder",
      measurements.shoulder,
      "in"
    ),

    measurementRow(
      "Sleeve",
      measurements.sleeve,
      "in"
    ),

    measurementRow(
      "Shirt Length",
      measurements.shirtLength,
      "in"
    ),

    measurementRow(
      "Pant Length",
      measurements.pantLength,
      "in"
    ),

    measurementRow(
      "Inseam",
      measurements.inseam,
      "in"
    ),

    measurementRow(
      "Neck",
      measurements.neck,
      "in"
    )

  ].join("");


  result.innerHTML = `
    <div class="schoolay-student-card">

      <div class="schoolay-student-card__top">

        ${
          photoUrl
            ? `
              <img
                class="schoolay-student-card__photo"
                src="${escapeHtml(photoUrl)}"
                alt="${escapeHtml(student.studentName)}"
                loading="lazy"
              >
            `
            : ""
        }

        <div>

          <h3 class="schoolay-student-card__name">
            ${escapeHtml(student.studentName)}
          </h3>

          <p class="schoolay-student-card__meta">
            <strong>School:</strong>
            ${escapeHtml(student.schoolName)}
          </p>

          <p class="schoolay-student-card__meta">
            <strong>Class:</strong>
            ${escapeHtml(classSection)}
          </p>

          <p class="schoolay-student-card__meta">
            <strong>Student ID:</strong>
            ${escapeHtml(student.studentId)}
          </p>

          <p class="schoolay-student-card__meta">
            <strong>Academic Year:</strong>
            ${escapeHtml(student.academicYear)}
          </p>

          <p class="schoolay-student-card__meta">
            <strong>Recommended Size:</strong>
            ${escapeHtml(student.recommendedSize || "-")}
          </p>

          <p class="schoolay-student-card__meta">
            <strong>Measurement Date:</strong>
            ${escapeHtml(
              formatDate(
                student.measurementDate
              )
            )}
          </p>

        </div>

      </div>


      <h3 class="schoolay-section-title">
        Body Measurements
      </h3>

      <div class="schoolay-measurements-grid">
        ${measurementHtml}
      </div>

    </div>
  `;

  result.hidden = false;

}

  function renderStudentSelector(students) {

    studentSelector.innerHTML = `
      <h3>Select Student</h3>

      <div class="schoolay-student-options">

        ${students.map(
          (student, index) => `
            <button
              type="button"
              class="schoolay-student-option"
              data-student-index="${index}"
            >
              <strong>
                ${escapeHtml(student.studentName)}
              </strong>

              <br>

              ${escapeHtml(student.schoolName)}
              —
              Class
              ${escapeHtml(student.className)}
              ${
                student.section
                  ? ` - ${escapeHtml(student.section)}`
                  : ""
              }
            </button>
          `
        ).join("")}

      </div>
    `;

    studentSelector.hidden = false;

    studentSelector
      .querySelectorAll(
        "[data-student-index]"
      )
      .forEach(button => {

        button.addEventListener(
          "click",
          function() {

            const index =
              Number(
                button.dataset.studentIndex
              );

            renderStudent(
              students[index]
            );

          }
        );

      });

  }


  form.addEventListener(
    "submit",
    async function(event) {

      event.preventDefault();

      clearMessage();

      result.hidden = true;

      studentSelector.hidden = true;

      result.innerHTML = "";

      studentSelector.innerHTML = "";


      const mobileNumber =
        mobileInput.value
          .replace(/\D/g, "")
          .trim();


      if (!/^[6-9]\d{9}$/.test(mobileNumber)) {

        showMessage(
          "Please enter a valid 10-digit mobile number."
        );

        return;

      }


      if (!apiUrl) {

        showMessage(
          "Student measurement API URL has not been configured."
        );

        return;

      }


      setLoading(true);


      try {

        const separator =
          apiUrl.includes("?")
            ? "&"
            : "?";

        const requestUrl =
          `${apiUrl}${separator}mobileNumber=${encodeURIComponent(
            mobileNumber
          )}`;


        const response =
          await fetch(
            requestUrl,
            {
              method: "GET",
              headers: {
                "Accept": "application/json"
              }
            }
          );


        if (!response.ok) {

          throw new Error(
            `Request failed with status ${response.status}`
          );

        }


        const payload =
          await response.json();


        if (
          !payload.success ||
          !Array.isArray(payload.data)
        ) {

          throw new Error(
            "Invalid response received."
          );

        }


        if (payload.data.length === 0) {

          showMessage(
            "No student measurement was found for this mobile number."
          );

          return;

        }


        if (payload.data.length === 1) {

          renderStudent(
            payload.data[0]
          );

          return;

        }


        renderStudentSelector(
          payload.data
        );

      } catch (error) {

        console.error(
          "Student measurement lookup error:",
          error
        );

        showMessage(
          "Unable to retrieve student measurements. Please try again."
        );

      } finally {

        setLoading(false);

      }

    }
  );

}


function initializeAllSchoolayMeasurementLookups() {

  document
    .querySelectorAll(
      "[data-schoolay-measurement]"
    )
    .forEach(
      initializeSchoolayMeasurementLookup
    );

}


if (document.readyState === "loading") {

  document.addEventListener(
    "DOMContentLoaded",
    initializeAllSchoolayMeasurementLookups
  );

} else {

  initializeAllSchoolayMeasurementLookups();

}


document.addEventListener(
  "shopify:section:load",
  function(event) {

    const root =
      event.target.querySelector(
        "[data-schoolay-measurement]"
      );

    if (root) {
      initializeSchoolayMeasurementLookup(root);
    }

  }
);


  } catch(e) { console.error(e); }
})();
})();
